import hostMap from './host'

const hostname = `${location.protocol}//${location.hostname}`

let login = hostMap[hostname] ? hostMap[hostname].login : hostMap.local.login
if (process.env.PROXY_ENV) {
  let hosts = Object.keys(hostMap).filter(host => hostMap[host].env === process.env.PROXY_ENV)
  if (hosts.length) {
    login = hostMap[hosts[0]].login
  }
  console.info(`当前cas环境: ${login}`)
}

export * from './appkey'

export const ENV = hostMap[hostname] && hostMap[hostname].env

export const API = {
  user: 'hr.remoteEmployee.getLoginUser',
  permission: 'auth.permission.getByUserId',
  permissionCode: 'auth.permission.getPermissionCodesByUserId',
  departmentLabel: 'hr.departmentLabel.getListSimple',
  menu: 'auth.menu.resources.loginUser.list',
  address: 'address.regionInfo.getMultiLevelSubListGat',
  login: login,
  validate: `${login}/cas_server/partner/v1/service/validate`
}

export const LOGIN_ERROR_TYPES = {
  login: '1', // 登录异常
  [API.menu]: '2', // 菜单异常
  [API.permission]: '3', // 权限异常
  [API.permissionCode]: '3', // 权限异常
  lookup: '4', // 数字字典异常
  expired: '5', // token 过期
  '2': 'menu',
  '3': 'permission'
}

export const REST = '/router/rest'

export const CHARTS_THEME = 'light'

// 首页置顶的常用模块
export const HOME_MENUS = (arr => {
  if (arr) {
    let item = arr.find(v => v.code === 'auth_menu_home')
    if (item && item.value) {
      return item.value
        .sort((a, b) => a.displaySequence - b.displaySequence)
        .map(v => v.lookupCode)
    }
  }
  return []
})(window.__ERPLOOKUP__)

export const PAGINATION = {
  layout: 'sizes, total, prev, pager, next',
  layout2: 'sizes, total, jumper, slot, prev, pager, next',
  pageSizes: [200],
  pageSize: 200
}

Object.assign(window.__ERPGLOABLECONFIG__, {
  exportTips: '是否要导出当前页数据？(数据导出将被后台监控)'
})



// WEBPACK FOOTER //
// ./src/public/config/index.js